/**
 * LA LECTURE DE L'OUVERTURE DEMANDÉE PAR LA BARRE DU HAUT.
 * ============================================================================
 *
 * La barre du haut a besoin de la lecture pour son entrée de menu. Au premier
 * rendu l'utilisateur peut ne pas être lu encore : la lecture suit donc
 * l'entreprise et l'offre (`watch` immédiat), pas le seul montage. Elle ne part
 * que pour une entreprise de l'offre Energy Manager : les autres comptes ne
 * paient aucun appel. Une session fermée (entreprise vide) referme le module.
 * La garde globale du routeur n'est pas touchée.
 *
 * Après une panne de la lecture (5xx, réseau coupé), rien n'est retenu
 * (`ouverture.store.ts`) : chaque navigation redemande, et l'entrée apparaît
 * dès que le serveur répond. Une lecture aboutie ne coûte plus aucune requête.
 */
import { inject, watch } from "vue"
import { routeLocationKey } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import { useOuvertureStore } from "@modules/alarmes-v2/stores/ouverture.store"

/** À appeler dans le `setup` d'un composant du cœur. */
export function useLectureOuverture(): void {
    const auth = useAuthStore()
    const ouverture = useOuvertureStore()
    // La route courante, absente hors routeur (tests, stories).
    const route = inject(routeLocationKey, null)
    watch(
        () =>
            [
                auth.companyId,
                auth.hasOfferEnergyManager,
                route?.fullPath ?? "",
            ] as const,
        ([societe, offreEm]) => {
            if (!societe || offreEm) void ouverture.charger()
        },
        { immediate: true }
    )
}
